export default {
  rmrecord: [],
  rmrecordlist: [],
  assignmono: [],
  assignrmname: [],
  getassigned: [],
  checkStatus: [],
  assignStatus: [],
  allassignagent: [],
  checknumber: [],
  statusFilter: {},
};
